import { useQuery, useMutation } from "@tanstack/react-query";
import {
  getResumeTemplates,
  getAllTemplatesPreview,
  getExportPreview,
  exportProfilePdf,
  exportProfileDocx,
  exportBulkPdf,
  exportBulkDocx,
  type ExportProfilePayload,
  type ExportBulkPayload,
} from "../api/template.api";
import { templateKeys, STALE_5_MIN } from "@/lib/queryKey";

export const useResumeTemplates = () =>
  useQuery({
    queryKey: templateKeys.lists(),
    queryFn: getResumeTemplates,
    ...STALE_5_MIN,
  });

export const useAllTemplatesPreview = (
  profileId?: string | number,
  enabled: boolean = true
) =>
  useQuery({
    queryKey: ["allTemplatesPreview", profileId],
    queryFn: () => getAllTemplatesPreview(profileId!),
    enabled: Boolean(enabled && profileId),
    ...STALE_5_MIN,
  });

export const useExportPreview = (
  id?: string | number | null,
  payload?: ExportProfilePayload,
  enabled: boolean = true
) =>
  useQuery({
    queryKey: ["exportPreview", id, payload],
    queryFn: () => getExportPreview(id!, payload!),
    enabled: Boolean(enabled && id && payload && payload.template),
  });

export const useExportPdf = () =>
  useMutation({
    mutationFn: ({
      id,
      payload,
      filename
    }: {
      id: string | number;
      payload: ExportProfilePayload;
      filename?: string;
    }) => exportProfilePdf(id, payload, filename),
  });

export const useExportDocx = () =>
  useMutation({
    mutationFn: ({
      id,
      payload,
      filename
    }: {
      id: string | number;
      payload: ExportProfilePayload;
      filename?: string;
    }) => exportProfileDocx(id, payload, filename),
  });

export const useExportBulkPdf = () =>
  useMutation({
    mutationFn: (payload: ExportBulkPayload) => exportBulkPdf(payload),
  });

export const useExportBulkDocx = () =>
  useMutation({
    mutationFn: (payload: ExportBulkPayload) => exportBulkDocx(payload),
  });